<div class="fee-row" [ngClass]="{'dark-color': useStrategyStyling}">
    <div class="fee-type">
        {{ ('entryFeeCalc.additionalFeesInfo.' + type) | translate }}:
    </div>

    <div class="value-tooltip-wrapper">
        <div class="value">
            {{ (value * 100) | number:'1.0-2'}} %
        </div>

        <div class="tooltip-container">
            <libero-tooltip-button [hidePerson]="true">
                @if(type === feeInfoItemTypes.EXIT && exitFeeTooltipValues) {
                    {{ 'entryFeeCalc.additionalFeesInfo.tooltips.EXIT.part1' | translate }}

                    {{ (exitFeeTooltipValues.exitFeeRatioYear1 * 100) | number:'1.0-2'}} %
                    {{ 'entryFeeCalc.additionalFeesInfo.tooltips.EXIT.in' | translate }}
                    2{{ 'entryFeeCalc.additionalFeesInfo.tooltips.EXIT.year' | translate }}

                    {{ (exitFeeTooltipValues.exitFeeRatioYear2 * 100) | number:'1.0-2'}} %
                    {{ 'entryFeeCalc.additionalFeesInfo.tooltips.EXIT.in' | translate }}
                    3{{ 'entryFeeCalc.additionalFeesInfo.tooltips.EXIT.year' | translate }}

                    {{ (exitFeeTooltipValues.exitFeeRatioYear3 * 100) | number:'1.0-2'}} %
                    {{ 'entryFeeCalc.additionalFeesInfo.tooltips.EXIT.in' | translate }}
                    4{{ 'entryFeeCalc.additionalFeesInfo.tooltips.EXIT.year' | translate }}

                    {{ (exitFeeTooltipValues.exitFeeRatioYear4 * 100) | number:'1.0-2'}} %
                    {{ 'entryFeeCalc.additionalFeesInfo.tooltips.EXIT.inSingle' | translate }}
                    5{{ 'entryFeeCalc.additionalFeesInfo.tooltips.EXIT.year' | translate }}
                    {{ (exitFeeTooltipValues.exitFeeRatioYear5 * 100) | number:'1.0-2'}} %

                    {{ 'entryFeeCalc.additionalFeesInfo.tooltips.EXIT.lastPart' | translate }}
                } @else {
                    {{ ('entryFeeCalc.additionalFeesInfo.tooltips.' + type) | translate }}
                }
            </libero-tooltip-button>
        </div>
    </div>
</div>